(() => {
  const TITLE_SELECTORS = [
    '[data-product-title]',
    '.pdp-title',
    '.ash-grid-text .ttl',
    'h2.product__title',
    '.ash-main-product-header > h2',
    '.product-card__title',
    '.ttl.lh-title',
    'h3.wi-name',
    '.ash-ss-product-info > h3',
    '.shop-the-look-product-card h4',
  ].join(',');

  const stripBrand = (text) =>
    text
      .replace(/\bashluxe\b/gi, '')
      .replace(/^\s*[-–—|:]\s*/, '')
      .replace(/\s{2,}/g, ' ')
      .trim();

  const cleanElement = (el) => {
    if (!(el instanceof Element)) return;

    const original = el.textContent || '';
    if (!/ashluxe/i.test(original)) return;

    const cleaned = stripBrand(original);
    if (!cleaned || cleaned === original.trim()) return;

    el.textContent = cleaned;
  };

  const scan = (root = document) => {
    if (root instanceof Element && root.matches(TITLE_SELECTORS)) {
      cleanElement(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(TITLE_SELECTORS).forEach(cleanElement);
    }
  };

  const start = () => {
    scan(document);

    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        scan(document);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    document.addEventListener('shopify:section:load', (event) => {
      scan(event.target);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
